/* eslint-disable react-native/no-inline-styles */
import {Button, Card, Layout, Modal, Text} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet, View, Image} from 'react-native';
import {hp, isLandscape as isLandscapeUtil, px, wp} from '../../../../utils';
import {TitleRow} from '../../../components';
import {whatsAppIcon} from '../../../../assets/images';
import {useSelector} from 'react-redux';

const NewPackageIntroModal = ({
  title,
  description,
  note,
  image,
  okButtonText,
  onClose,
  onConfirm,
}) => {
  const user = useSelector((state) => state.auth.user);

  const whatsAppNumber = '+60182259941';

  const handleWhatsApp = () => {
    const {fullName, gradeName, email} = user;
    let message = 'I want to register for *Programme Score A*.';
    if (fullName) {
      message += `\n\nName: ${fullName}`;
    }
    if (gradeName) {
      message += `\nGrade: ${gradeName}`;
    }
    if (email) {
      message += `\nEmail: ${email}`;
    }

    window.open(
      `https://wa.me/${whatsAppNumber}?text=${encodeURIComponent(message)}`,
      '_blank',
    );
  };

  return (
    <Modal
      visible={true}
      backdropStyle={styles.backdrop}
      style={{
        backgroundColor: 'transparent',
        borderRadius: 10,
        boxShadow: '10px 10px 30px -12px rgba(0,0,0,0.75)',
      }}
      onBackdropPress={() => onClose()}>
      <Card disabled={true}>
        <Layout style={styles.container}>
          <TitleRow
            title={''}
            type="primary"
            iconName="close-circle-outline"
            onIconClick={() => onClose()}
            containerStyle={styles.title}
          />
          <View style={styles.boxContainer}>
            <Text style={styles.primaryText}>
              {
                'Congratulation! Your Registration for Programme A–Z Revision is almost complete!'
              }
            </Text>
            <Text style={styles.secondaryText}>
              {'Make sure to register for '}
              <Text style={{fontWeight: 'bold'}}>Programme Score A</Text>
              {
                ' also, which is an additional programme designed to teach high-scoring strategies and help students prepare for their final exams.'
              }
            </Text>

            <Text style={styles.noteText}>
              {'Conducted on Saturdays & Sundays'}
            </Text>
            <Text style={styles.secondaryText}>
              {
                'To register, click the button below to WhatsApp to Star Tutor Team:'
              }
            </Text>

            <View style={{flexDirection: 'row', justifyContent: 'center'}}>
              <View>
                <Button onPress={handleWhatsApp} style={styles.submitButton}>
                  {(evaProps) => (
                    <>
                      <Image
                        source={whatsAppIcon}
                        style={styles.whatsAppIcon}
                      />
                      <Text
                        {...evaProps}
                        style={[evaProps.style, styles.buttonText]}>
                        {'018 – 225 9941'}
                      </Text>
                    </>
                  )}
                </Button>
              </View>
            </View>
          </View>
        </Layout>
      </Card>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    width: isLandscapeUtil() ? wp(50) : wp(80),
    height: isLandscapeUtil() ? hp(60) : hp(90),
  },
  boxContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '80%',
    paddingHorizontal: px(20),
  },
  backdrop: {
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },
  title: {
    width: '100%',
  },
  heading: {
    fontWeight: '600',
    fontSize: 22,
    textAlign: 'center',
    marginTop: px(50),
  },
  primaryText: {
    fontWeight: '600',
    fontSize: 18,
    textAlign: 'center',
    marginTop: px(20),
    marginBottom: px(20),
  },
  secondaryText: {
    fontWeight: '400',
    textAlign: 'center',
    fontSize: 17,
    marginBottom: px(20),
    lineHeight: 24,
  },
  noteText: {
    fontWeight: '600',
    textAlign: 'center',
    marginHorizontal: px(17),
    marginBottom: px(17),
    fontSize: 17,
  },
  input: {
    marginHorizontal: px(17),
    marginBottom: px(17),
  },
  submitButton: {
    marginHorizontal: px(5),
    marginTop: px(26),
    marginBottom: px(17),
    width: px(300),
  },
  rowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    margin: px(17),
    marginTop: px(28),
  },
  whatsAppIcon: {
    width: px(25),
    height: px(25),
  },
});

export default NewPackageIntroModal;
